<template>
  <div :class="['fo-box', {'unavailable':!flightOption.available}]">
    <div class="fo-price d-flex align-end">
      <span v-if="isReturning && activeLeg === 'leg2'">+</span>
      <span v-if="service.available && currency.code === 'USD'">$ {{parseFloat((flightOption.payment.totalWithMarkUp + otherLegPrice()).toFixed(2))}}</span>
      <span v-else-if="service.available && currency.code !== 'USD'">{{ applyCurrency(flightOption.payment.totalWithMarkUp + otherLegPrice())}}</span>
      <span v-else>N/A</span>
    </div>
    <div class="fo-cabin">Cabin: {{ cabinLabel(flightOption.cabin) }} Class</div>
    <ul class="fo-info">
      <li>
        <i class="fas fa-thumbs-up"></i>
        <div class="f-li-full">{{ cabinDesc(flightOption.cabin) }}</div>
        <div class="f-tp">
          <i class="fas fa-check" @mouseover="tp.first = true" @mouseleave="tp.first = false"></i>
          <transition name="slide-left">
            <div class="f-tp-msg" v-show="tp.first">Included in this flight</div>
          </transition>
        </div>
      </li>
      <li>
        <i class="fas fa-virus"></i>
        <div class="f-li-full" v-if="flightOption.isRefundable">Refundable</div>
        <div class="f-li-full" v-else>Non-Refundable</div>
        <div class="f-tp">
          <i class="fas fa-check" @mouseover="tp.second = true" @mouseleave="tp.second = false"></i>
          <transition name="slide-left">
            <div class="f-tp-msg" v-show="tp.second">Included in this flight</div>
          </transition>
        </div>
      </li>
      <!-- <li>
        <img src="../../assets/img/backpack.png" />
        <div class="f-li-full">Personal Item {{ service.flight[0].personalitem }}</div>
        <div class="f-tp">
          <i :class="['fas', optionStatus(flightOption.cabin, 'personalItem', flightOption.personalItem)]" @mouseover="tp.third = true" @mouseleave="tp.third = false"></i>
          <transition name="slide-left">
            <div class="f-tp-msg" v-show="tp.third">
              <span v-if="optionStatus(flightOption.cabin, 'personalItem', flightOption.personalItem) === 'fa-check'">Included in this flight</span>
              <span v-else>Chargeable</span>
            </div>
          </transition>
        </div>
      </li> -->
      <li>
        <i class="fas fa-briefcase"></i>
        <div class="f-li-full">1 Carry-On Bag per person</div>
        <div class="f-tp">
          <i :class="['fas', optionStatus(flightOption.cabin, 'carryOnBag', flightOption.hasCarryOn)]" @mouseover="tp.fourth = true" @mouseleave="tp.fourth = false"></i>
          <transition name="slide-left">
            <div class="f-tp-msg" v-show="tp.fourth">
              <span v-if="optionStatus(flightOption.cabin, 'carryOnBag', flightOption.hasCarryOn) === 'fa-check'">Included in this flight</span>
              <span v-else>Chargeable</span>
            </div>
          </transition>
        </div>
      </li>
      <li>
        <img src="../../assets/img/luggage.png" />
        <div class="f-li-full">Check-In Bag - 1 Piece per person</div>
        <div class="f-tp">
          <i :class="['fas', optionStatus(flightOption.cabin, 'checkedBag', flightOption.hasCheckInBag)]" @mouseover="tp.fifth = true" @mouseleave="tp.fifth = false"></i>
          <transition name="slide-left">
            <div class="f-tp-msg" v-show="tp.fifth">
              <span v-if="optionStatus(flightOption.cabin, 'checkedBag', flightOption.hasCheckInBag) === 'fa-check'">Included in this flight</span>
              <span v-else>Chargeable</span>
            </div>
          </transition>
        </div>
      </li>
      <li>
        <img src="../../assets/img/seat.png" />
        <div class="f-li-full">{{ seatChoice(flightOption.cabin) }}</div>
        <div class="f-tp">
          <i :class="['fas', optionStatus(flightOption.cabin, 'seatSelection')]" @mouseover="tp.sixth = true" @mouseleave="tp.sixth = false"></i>
          <transition name="slide-left">
            <div class="f-tp-msg" v-show="tp.sixth">
              <span v-if="optionStatus(flightOption.cabin, 'seatSelection') === 'fa-check'">Included in this flight</span>
              <span v-else>Chargeable</span>
            </div>
          </transition>
        </div>
      </li>
      <li>
        <i class="fas fa-calendar-plus"></i>
        <div class="f-li-full">Flight Change Or Cancel</div>
        <div class="f-tp">
          <i :class="['fas', optionStatus(flightOption.cabin, 'flightChange')]" @mouseover="tp.seventh = true" @mouseleave="tp.seventh = false"></i>
          <transition name="slide-left">
            <div class="f-tp-msg" v-show="tp.seventh">
              <span v-if="optionStatus(flightOption.cabin, 'flightChange') === 'fa-check'">Included in this flight</span>
              <span v-else>Chargeable</span>
            </div>
          </transition>
        </div>
      </li>
      <li>
        <i class="fas fa-utensils"></i>
        <div class="f-li-full">Snacks & Drinks</div>
        <div class="f-tp">
          <i :class="['fas', optionStatus(flightOption.cabin, 'snacksDrinks')]" @mouseover="tp.eighth = true" @mouseleave="tp.eighth = false"></i>
          <transition name="slide-left">
            <div class="f-tp-msg" v-show="tp.eighth">
              <span v-if="optionStatus(flightOption.cabin, 'snacksDrinks') === 'fa-check'">Included in this flight</span>
              <span v-else>Chargeable</span>
            </div>
          </transition>
        </div>
      </li>
      <li>
        <i class="fas fa-wifi"></i>
        <div class="f-li-full">Wi-Fi</div>
        <div class="f-tp">
          <i :class="['fas', optionStatus(flightOption.cabin, 'wifi')]" @mouseover="tp.ninth = true" @mouseleave="tp.ninth = false"></i>
          <transition name="slide-left">
            <div class="f-tp-msg" v-show="tp.ninth">
              <span v-if="optionStatus(flightOption.cabin, 'wifi') === 'fa-check'">Included in this flight</span>
              <span v-else>Chargeable</span>
            </div>
          </transition>
        </div>
      </li>
      <!-- <li>
        <i class="fas fa-user-shield"></i>
        <div class="f-li-full">Shortcut Security</div>
        <i :class="['fas', optionStatus(flightOption.cabin, 'shortcutSecurity')]"></i>
      </li> -->
      <!-- <li>
        <i class="fas fa-car-side"></i>
        <div class="f-li-full">
          Home pickup & drop with Pro Drivers with
          {{ cabinGroundService(flightOption.cabin) }}
        </div>
      </li> -->
    </ul>
    <div class="lr-btn select-btn" @click="selectFlight">
      <span v-if="flightOption.available">SELECT</span>
      <span v-else>Not Available</span>
    </div>
  </div>
</template>

<script>
import xcurrency from '@/modules/api/currency'
import servicePrice from '@/modules/api/service-price'

export default {
  name: 'flight-option',
  props: ['flightOption', 'service'],
  data () {
    return {
      tp: {
        first: false,
        second: false,
        third: false,
        fourth: false,
        fifth: false,
        sixth: false,
        seventh: false,
        eighth: false,
        ninth: false
      }
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    isReturning () { return this.filters.departure.isReturning },
    activeLeg () { return this.booking.activeLeg },
    other () { return this.$store.state.other },
    currency () { return this.other.currency }
  },
  methods: {
    otherLegPrice () {
      return servicePrice.otherLegPrice(this, this.activeLeg)
    },
    applyCurrency (x, useSymbol = true, noComma = false) {
      x = x.toString().replace(/[',']/g, '')
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) return parseFloat(x.toFixed(2))
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol, noComma)
    },
    cabinLabel (x) {
      if (x === 'PremiumEconomy') return 'Premium Economy'
      return x
    },
    cabinDesc (x) {
      if (x === 'Economy') return 'Fly Smart, Save More'
      if (x === 'PremiumEconomy') return 'Step Up Your Comfort'
      if (x === 'Business') return 'Business, But Better'
      if (x === 'First') return 'Luxury in the Skies'
    },
    seatChoice (x) {
      if (['Economy', 'PremiumEconomy'].indexOf(x) > -1) return 'Seat Choice - Chargeable'
      if (['Business', 'First'].indexOf(x) > -1) return 'Seat Choice - Non-Chargeable'
    },
    cabinGroundService (x) {
      if (x === 'Economy') return 'Express'
      if (x === 'PremiumEconomy') return 'Express SUV'
      if (x === 'Business') return 'Business Class'
      if (x === 'First') return 'Black Car'
    },
    selectFlight () {
      if (!this.flightOption.available) return
      this.$emit('check', this.flightOption)
    },
    optionStatus (cabin, option, force = null) {
      let freeIcon = 'fa-check'
      let payIcon = 'fa-minus-circle'
      // let freeIcon = '<i class="fas fa-check"></i>'
      // let payIcon = '<i class="fas fa-dollar-sign"></i>'
      if (force === true) return freeIcon
      if (force === false) return payIcon

      if (option === 'personalItem' || ['Business', 'First'].indexOf(cabin) > -1) return freeIcon
      if (cabin === 'Economy') return payIcon

      if (cabin === 'PremiumEconomy') {
        let free = ['carryOnBag', 'seatSelection', 'flightChange']
        let pay = ['checkedBag', 'snacksDrinks', 'wifi', 'shortcutSecurity']
        if (free.indexOf(option) > -1) return freeIcon
        if (pay.indexOf(option) > -1) return payIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fo-box{
  border: 1px solid #abb2b8;
  border-radius: 6px;
  padding: 10px;
  background: #fff;
  max-width: 270px;
  flex: 0 0 270px;
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;

  &.unavailable{
    opacity: .6;

    .lr-btn{
      cursor: default;
    }
  }
}
.fo-price{
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 5px;
  
  span{
    margin-left: 3px;  
  }
}
.fo-cabin{
  background: #fbefd2;
  padding: 7px 15px;
  font-weight: 600;
  color: #8e651a;
  font-size: 14px;
  margin-bottom: 15px;
  border-radius: 20px;
  display: inline-block;
  letter-spacing: .6px;
  line-height: 1;
}
.fo-info{
  list-style: none;
  padding: 0 0 0 5px;
  margin: 0 0 30px;
  flex-grow: 1;

  li{
    font-size: 14px;
    vertical-align: -1px;
    line-height: 1;
    display: flex;
    align-items: center;
    gap: 10px;

    &:not(:last-child){
      margin-bottom: 15px;
    }
  }
  i{
    font-size: 18px;
    color: #4e4e4e;
    
    // &.fa-car-side, &.fa-thumbs-up, &.fa-virus{
      //   color: #2fd647;
      // }
    &.fa-check{
      color: #2fd647;
    }
    &.fa-minus-circle{
      color: #e7b81d;
      font-size: 17px;
    }
  }
  img{
    width: 18px;
    padding-bottom: 4px;
  }
  .f-li-full{
    line-height: 1.35;
    color: #444;
    letter-spacing: .5px;
    font-size: 13px;
    width: 100%;
  }
  .f-tp{
    position: relative;
  }
  .f-tp-msg{
    position: absolute;
    top: calc(100% + -5px);
    right: 14px;
    background: #f0f0f0;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, .4);
    color: #000;
    padding: 4px 10px;
    border-radius: 4px;
    line-height: 1;
    font-size: 11px;
    letter-spacing: .9px;
    white-space: nowrap;
  }
}
.select-btn{
  letter-spacing: 1.5px;
  border-radius: 20px;
  font-size: 15px;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.1s ease-out;
}
.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(5px);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// FlightOption.vue?8fa1ef6e